import { render, staticRenderFns } from "./MusicSidebar.vue?vue&type=template&id=42e7d59d"
import script from "./MusicSidebar.vue?vue&type=script&lang=js"
export * from "./MusicSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports